const indexSelectors = {
  instanFeed: document.getElementById('index-instagram-feed'),
};
class templalteIndexJS {
  constructor() {
    if (indexSelectors.instanFeed) this.manageInstaJS();
    this.logoSlider();
  }

  manageInstaJS() {
    const onIntersection = entries => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          let instaScript = document.createElement('script');
          instaScript.src =
            'https://cdn.nfcube.com/d625e6c256304ac7278dae5d1df06df6.js';
          instaScript.dataset.shopname = 'grill-masters-club.myshopify.com';
          document.body.appendChild(instaScript);
          observer.disconnect();
        }
      }
    };
    const observer = new IntersectionObserver(onIntersection);
    observer.observe(indexSelectors.instanFeed);
  }
  logoSlider() {
    let w = window.innerWidth;
    //   if (w < 991) {
    let slidesPerView = 2;

    // change slidesPerView to larger numbers on larger screen sizes
    if (w > 1200) {
      slidesPerView = 5;
    } else if (w > 800) {
      slidesPerView = 4;
    } else if (w > 500) {
      slidesPerView = 3;
    }

    var swiper = new Swiper('.full-logo-list .swiper', {
      loop: true,
      slidesPerView,
      spaceBetween: 20,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false,
      },
    });
    //   }
  }
}
typeof templalteIndexJS !== 'undefined' && new templalteIndexJS();
